import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCalendarCropped = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	fill: "none",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#111",
		fillRule: "evenodd",
		d: "M15 5H9V3H7v2H3v16h18V5h-4V3h-2v2zM7 9V7H5v3h14V7h-2v2h-2V7H9v2H7zm-2 3v7h14v-7H5z",
		clipRule: "evenodd"
	})
});
export default SvgCalendarCropped;
